angular.module('leanlaw').controller('AttorneyBillableCtrl', ['$scope', '$rootScope', '$q', '$filter', '$state', "alerts", 'userService', 'reportsService', 'singleRequest', "exportJson", "messageBus", function ($scope, $rootScope, $q, $filter, $state, alerts, userService, reportsService, singleRequest, exportJson, messageBus) {
  $scope.filter = {};
  $scope.search = "";
  $scope.sort = 'user.name';
  $scope.reverse = false;
  $scope.loading = true;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const exp = $scope.data.filtered.reduce((accum, c) => {
      const item = {
        "User": c.user.name,
        "Hourly": $filter("amount")(c.data.amounts.hours),
        "Fixed Fees": $filter("amount")(c.data.amounts.charges)
      };
      if ($scope.me.company.usesContingency) {
        item["Contingency"] = $filter("amount")(c.data.amounts.contingency);
      }
      item["Total"] = $filter("amount")(c.data.amounts.total + c.data.amounts.contingency);
      item["Expenses"] = $filter("amount")(c.data.amounts.expenses);
      accum.push(item);
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };

  // if Unassigned don't go to detail page
  $scope.gotoDetail = function (user) {
    $state.go("reports.attorney-billable-detail", {
      userId: user.id
    });
  };
  activate();

  ///////////////////////////////////////

  function activate() {
    userService.me().then(me => {
      $scope.me = me;
      $scope.$on('commonFilterService-statechanged', (event, payload) => {
        if (!payload) return;
        // Assigning to existing filter keeps custom filter options
        $scope.filter = Object.assign($scope.filter, payload);
        // Necessary to set this value for the requests
        $scope.filter.status = $scope.filter.archived.status;
        $scope.filter.scope = $scope.filter.filter.scope;
        $scope.filter.startDate = $scope.filter.filter.range.startDate;
        $scope.filter.endDate = $scope.filter.filter.range.endDate;
        $scope.filter.scopeAccount = $scope.filter.filter.scopeAccount ? $scope.filter.filter.scopeAccount.id : null;
        $scope.filter.billedState = $scope.filter.billedFilter && $scope.filter.billedFilter.id;
        if (payload.filter.range) {
          filterClientEntries();
        }
      });
      $scope.$on("report-sidebar-filterchange", (event, payload) => {
        $scope.filter = Object.assign($scope.filter, payload);
      });

      // MessageBus is used here so that the commonFilter module can pick it up once it loads
      messageBus.addMessage("filterDependency-ready", true);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("report");
    singleRequest.cancel("report2");
    deactivate();
  });
  function filterClientEntries() {
    const query = reportsService.queryFromFilter($scope.filter);
    query.data = "services,expenses,charges";
    query.primary = 'users';
    query.reportType = 'billable';
    $scope.loading = true;
    const requests = [singleRequest.serviceCall("report", reportsService.getReport)(query)];
    if ($scope.me.company.usesContingency) {
      query.data = "cost";
      query.billingType = "contingency";
      requests.push(singleRequest.serviceCall("report2", reportsService.getReport)(query));
    }
    $q.all(requests).then(([data, contingency]) => {
      if (!data) return; // happens if we were canceled
      $scope.data = data;
      if (contingency) {
        // merge contingency data in with other data
        contingency.users.forEach(user => {
          const amount = user.data.hours.nonBillableCost;
          if (amount) {
            let existing = data.users.find(u => u.user.id === user.user.id);
            if (!existing) {
              existing = user;
              user.data.amounts = {};
              data.users.push(existing);
            }
            existing.data.amounts.contingency = amount;
          }
        });
        data.data.amounts.contingency = contingency.data.hours.nonBillableCost;
      }
      if ($scope.data.unallocated) {
        $scope.data.users.push({
          user: {
            name: "Unassigned"
          },
          data: {
            amounts: $scope.data.unallocated.amounts
          }
        });
        Object.keys($scope.data.data.amounts).forEach(a => {
          $scope.data.data.amounts[a] = $scope.data.data?.amounts[a] + $scope.data.unallocated?.amounts[a];
        });
      }
      $scope.loading = false;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filtered = $filter('orderBy')($filter('filter')($scope.data.users, $scope.search), $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.users', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);